// theme.ts
import { createTheme } from "@mui/material";
import type {
  PaletteOptions as MuiPaletteOptions,
  Palette as MuiPallete,
} from "@mui/material/styles/createPalette";

declare module "@mui/material/styles/createPalette" {
  type Palette = {
    toReturn: {
      main: string;
      contrastText: string;
    };
    Standard: {
      main: string;
      contrastText: string;
    };
    TWO_WAY_DELIVERY: {
      main: string;
      contrastText: string;
    };
    OKM: {
      main: string;
      contrastText: string;
    };
  } & MuiPallete;
  // @ts-expect-error: PaletteOptions recursively references itself as a base type
  type PaletteOptions = {
    toReturn?: {
      main: string;
      contrastText: string;
    };
    Standard?: {
      main: string;
      contrastText: string;
    };
    TWO_WAY_DELIVERY?: {
      main: string;
      contrastText: string;
    };
    OKM?: {
      main: string;
      contrastText: string;
    };
  } & MuiPaletteOptions;
}

export const theme = createTheme({
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
  },
  palette: {
    background: {
      default: "#f9f5f5ff",
    },
    primary: {
      main: "#00244f",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ff5c8d",
      contrastText: "#fff",
    },
    toReturn: {
      main: "#D4A81B",
      contrastText: "#fff",
    },
    Standard: {
      main: "#1A5DA6",
      contrastText: "#fff",
    },
    TWO_WAY_DELIVERY: {
      main: "#8A4FCE",
      contrastText: "#fff",
    },
    OKM: {
      main: "#3DA58A",
      contrastText: "#fff",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: '"Montserrat", "sans-serif"',
          fontWeight: 400,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // backgroundColor: "oklch(92.9% 0.013 255.508)",
          // borderRadius: 8,
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          lineHeight: 1.5,
          letterSpacing: "0.04rem",
          fontSize: "0.8rem",
          "&:focus-visible": {
            outline: "2px solid #00244f",
            outlineOffset: "2px",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          "&:focus-visible": {
            outline: "2px solid #00244f",
            outlineOffset: "2px",
          },
        },
      },
    },
  },
});
